import { connect } from 'react-redux'
import * as actions from '../../actions'
import { SNSShareDialog } from '../../components'

const mapStateToProps = (state, ownProps) => {
  const { language } = state.user
  return ({
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    notify: (message, variant) => {
      dispatch(actions.snackbar.notify(message, variant))
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SNSShareDialog)


// WEBPACK FOOTER //
// ./src/containers/Common/SNSShareDialog.js